/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Apr 27 2022
*  File : common.ts
*******************************************/

import { PropertyConfig } from "@api-commons/config/PropertyConfig.js";
import { BarrierDisplayMode } from "@api-commons/sdk/aaa/AAABarrierWithSource.js";

const domain = "fanpage.run";
const host = "api." + domain;
const secure = true;




export const commonConfig: PropertyConfig = {
    version: "8.0.0",
    debug: true,
    host: host,
    domain: domain,
    site: "fanpage",
    siteName: "Fanpage.it",
    mainUrl: "https://www.fanpage.run",
    assetsDistro: "https://assets.fanpage.run",
    assetsCacheBuster: "1671030819",
    serverSdkEndpoint: "/embed/channel70",
    sdkJsServer: {
        domain: domain,
        host: domain,
        path: "/local/fanpage/sdk/fanpage-server-sdk-dev.js",
        secure: true
    },
    secure: secure,
    applicationToken: {
        
        android: "511505365679|37cbad27d60aa2750bfc51922728136f458d04321f07986d19149a68e98ef875",
        ios: "12433865532|O1238da-89230kmqwerq9ASDFasd88_4kasdbnASD324BDPPtw",
        web: "723315188865|mEckHhabNKMnbwWR12bFbZ2ZyV4bhpL5KCVpkOrXX9EkDkwvUJa0mxz5pPDm3oqZ"
    },
    cookies: {
        names: {
            session: "fp_ut",
            logout: "fp_lo",
            fbToken: "fp_fbtk",
            aes: "fp_ad",
            loginPreviousState: "fp_lpsnu",
            lastLoginProvider: "fp_lprov",
            audienceToken: "apat"
        },
        cookieDomain: ".fanpage.run",
        cookieversion: 8,
    },
    loginManager: {
        barrierDisplayMode: BarrierDisplayMode.SHOW_DIALOG,
        actual_providers: {
            facebook: {
                enabled: true,
                applicationIdentifier: "157667184275734",
                scopes: ["public_profile", "email", "user_birthday", "user_gender"]
            },
            google: {
                enabled: true,
                applicationIdentifier: "591843941662-g6lr668l0ujmpqat57cs1cn29l3gjb99.apps.googleusercontent.com",
                scopes: ["https://www.googleapis.com/auth/user.gender.read", "https://www.googleapis.com/auth/user.birthday.read"]
            },
            apple: {
                enabled: true,
                scopes: ['email', 'name'],
                // @note workaround perchè non utilizzato direttamente
                applicationIdentifier: ""
            },
            email: {
                enabled: true,
                scopes: [],
                applicationIdentifier: ""
            }
        },
        /**
         * firebase app configuration goes here
         */
        firebase: {
            apiKey: "AIzaSyAtlAnkDiq0_X8olkJ81gHvhvaK9eo0-TQ",
            authDomain: "fanpage-users-staging.firebaseapp.com",
            projectId: "fanpage-users-staging",
            storageBucket: "fanpage-users-staging.appspot.com",
            messagingSenderId: "591843941662",
            appId: "1:591843941662:web:5df8bce63122324da83d0f"
        },
        autologin: {
            enabled: true,
            retrieveActualDataAlways: false,
        },
        firebaseAccountMergeEnable: true,
        revokeOnClientSideOnDeletion: true
    },
    // parse: {
    //     login: false,
    //     follows: true,
    //     bookmarks: false
    // },
    support: {
        native_apps: true,
        bookmarks: false,
        newsletters: true
    },
    nativeApp: {
        product: "fanpage",
        schema_intent: "fanpage",
        ios_alternative_url: "https://fanpa.ge/fanpage_ios", //https://apps.apple.com/it/app/fanpage/id536492568
        android_alternative_url: "https://fanpa.ge/fanpage_android", //https://play.google.com/store/apps/details?id=com.ciaopeople.fanpage,
        dynamicLink: {
            baseUrl: "https://ciaopeople.page.link/",
            apn: "com.ciaopeople.fanpage",
            amv: "3",
            ibi: "com.ciaopeople.fanpage",
            isi: "536492568",
            ius: "fanpage"
        }
    },
    webPush: {
        publicKey: "BNhQfsDbIbj/1jSwoyZ9saq/6EPEFSCYPeWOiXN7NRcs3qPV2Sf1sfN+xgxF+ExQNZMEb4qp7VFa72Z4yDLIBSI=",
        vapiKey: "BNhQfsDbIbj_1jSwoyZ9saq_6EPEFSCYPeWOiXN7NRcs3qPV2Sf1sfN-xgxF-ExQNZMEb4qp7VFa72Z4yDLIBSI",
        serviceWorkerPath: "/serviceworker/v7/sw.js",
        serviceWorkerHost: "fanpage.run"
    },
    snhubConfig: {
        host: host,
        domain: domain,
        secure: secure,
        enabled: true,
        cookies: {
            userdata: "fp_snu_ud",
            token: "fp_snu_tk",
            oldToken: "fp_snu_oldtk",
            next_check: "fp_snu_nc",
            role: "fp_snu_role" //?TODO: Inventato, non ho trovato un corrispettivo
        }
    },
    ga4: {
        accountId: "G-QE4WQDQJ7S",
        cookieDomain: ".fanpage.run"
    },
    contacts: {
        dataDeletionEmail: "richieste-cancellazione@fanpage.it"
    },
    appDownloadLink: {
        "app-store": "https://search.itunes.apple.com/WebObjects/MZContentLink.woa/wa/link?mt=8&path=apps%2fciaopeoplesrl%2ffanpage?ref=shortener",
        "google-play": "https://play.google.com/store/apps/details?id=com.ciaopeople.fanpage&ref=shortener"
    },
    links: {
        privacyPolicy: "https://www.fanpage.it/privacy-policy/"
    }
};
